import React from "react";
import { Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import {
  Icon1CircleFill,
  Icon2CircleFill,
  Icon3CircleFill,
  ChevronRight,
  CheckCircleFill,
} from "react-bootstrap-icons";
import classNames from "classnames";
import useIsDomainMode from "../../../hooks/useIsDomainMode";

interface IStepsInfoProps {
  step: number;
}

export default function StepsInfo({ step }: IStepsInfoProps) {
  const { t } = useTranslation();
  const isDomainMode = useIsDomainMode();

  const IconStep1 = step < 2 ? Icon1CircleFill : CheckCircleFill;
  const IconStep2 = step < 3 ? Icon2CircleFill : CheckCircleFill;
  const IconStep3 = step < 3 ? Icon3CircleFill : CheckCircleFill;

  const classes = (
    defaultStep: number,
    classesForDefault: string,
    classesForActive: string
  ) => (step >= defaultStep ? classesForActive : classesForDefault);

  return (
    <div className="mb-4 mx-auto bg-sec-background-gray p-3 rounded-2 border border-sec-background d-flex justify-content-center align-items-center">
      <Col xs={12} md={9}>
        <ul
          className="d-flex list-unstyled justify-content-center justify-content-md-between align-items-center overflow-auto w-100 mb-0 gap-2"
          style={{
            overflowX: "auto",
            msOverflowStyle: "none",
            scrollbarWidth: "none",
          }}
        >
          <li
            className="d-flex align-items-center text-nowrap"
            id="domainStep1"
          >
            <IconStep1 className="fs-4 text-success me-md-2" />
            <span className="fw-bold d-none d-md-block">
              {isDomainMode
                ? t("whiteLabel.Domain Name")
                : t("whiteLabel.Subdomain Name")}
            </span>
          </li>
          <li>
            <ChevronRight
              className={classNames(
                "mx-3 mx-md-0",
                classes(2, "text-light", "text-dark")
              )}
            />
          </li>
          <li
            className="d-flex align-items-center text-nowrap"
            id="domainStep2"
          >
            <IconStep2
              className={classNames(
                "fs-4 me-md-2",
                classes(2, "text-sec-background", "text-success")
              )}
            />
            <span
              className={classNames(
                "d-none d-md-block",
                classes(2, "text-sec-background", "text-dark fw-bold")
              )}
            >
              {t("whiteLabel.Setup & Connect")}
            </span>
          </li>
          <li>
            <ChevronRight
              className={classNames(
                "mx-3 mx-md-0",
                classes(2, "text-sec-background", "text-dark")
              )}
            />
          </li>
          <li
            className="d-flex align-items-center text-nowrap"
            id="domainStep3"
          >
            <IconStep3
              className={classNames(
                "fs-4 me-md-2",
                classes(3, "text-sec-background", "text-success")
              )}
            />
            <span
              className={classNames(
                "d-none d-md-block",
                classes(3, "text-sec-background", "text-dark fw-bold")
              )}
            >
              {t("whiteLabel.Complete Setup")}
            </span>
          </li>
        </ul>
      </Col>
    </div>
  );
}
